import React from 'react'

import { Button, Modal } from '../../../../components/DesignSystem'

import './index.scss'

export default function ConfirmationModal({ show, onClose, onConfirmation }) {

  function handleConfirmation() {
    onConfirmation()
    onClose()
  }

  function renderChildren() {
    return (
      <p className='modal-confirmation__content'>
        Confira se todas as informações estão corretas.
      </p>
    )
  }

  function renderFooter() {
    return (
      <div style={{ gap: '8px' }}>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          contained
          onClick={handleConfirmation}
        >
          Confirmar
        </Button>
      </div>
    )
  }

  return (
    <Modal
      show={show}
      title='Confirmar envio'
      children={renderChildren()}
      renderFooter={renderFooter()}
      onClose={onClose}
    />
  )
}